<template>
    <div class="help-edit">
        <data-form title="Help Message Edit"
                   tag="help-edit"
                   save-button-label="Save"
                   :field-model="helpFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/help/view/${helpId}`"
                   submit-success-message="Help message updated"
                   submit-error-message="Error updating help message"
                   :submit-success-route="`/help/view/${helpId}`">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import HelpFields from '@/models/Help'

export default Vue.extend({
    name: 'HelpEdit',
    props: {
        helpId: Number,
    },
    data () {
        return {
            helpFields: HelpFields,
            fieldGroups: [
                ['id', 'tag', 'content']
            ],
        }
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'help', this.helpId)
        },
        onSubmit (modelInstance) {
            this.$store.dispatch('submit', {
                mutation: 'clearHelps'
            })
            return this.$api.updateItem(this, 'help', modelInstance)
        },
    }
})

</script>
